import React, {useCallback} from "react";
import LoginSceneLayout from "~/layouts/LoginSceneLayout";
import ReactDocumentTitle from "~/components/ReactDocumentTitle";
import {createUseStyles} from "react-jss";
import UIButton from "~/old-ui/UIButton";
import UIInput from "~/old-ui/UIInput";
import {reverse} from "~/urls";
import useFormState from "~/hooks/useFormState";
import {useFetchResetPassword} from "~/backend";
import UINotification from "~/old-ui/UINotification";
import UIForm from "~/old-ui/UIForm";
import LoginErrorNotification from "~/components/LoginErrorNotification";
import {getQueryParam, setQueryParams} from "~/utils";
import {useHistory} from "react-router";
import {mediaSizes} from "~/theme";
import ReactLink from "~/components/ReactLink";

export default function ResetPasswordScene() {
  const classes = useStyles();
  const history = useHistory();

  const [formData, setFormData] = useFormState({email: ''});
  const onInputChange = useCallback((fieldName) => {
    return (e) => setFormData({[fieldName]: e.target.value})
  }, [setFormData]);

  const [fetchResetPassword, fetchResetPasswordState, fetchResetPasswordResetState] = useFetchResetPassword();
  const externalErrorCode = getQueryParam(history, 'err');
  const resetExternalErrorCode = useCallback(() => {
    if (externalErrorCode) {
      setQueryParams(history, {err: null});
    }
  }, [history, externalErrorCode]);
  const onSubmit = useCallback(() => {
    resetExternalErrorCode();
    fetchResetPassword({email: formData.email});
  }, [history, formData]);

  return (
    <>
      <ReactDocumentTitle title='Reset password'/>
      <LoginSceneLayout>
        <h1 className={classes.h1}>Reset password for Workshop Butler</h1>

        {externalErrorCode && (
          <LoginErrorNotification
            className={classes.notification}
            errorCode={externalErrorCode}
            closable
            onClose={resetExternalErrorCode}
          />
        )}

        {fetchResetPasswordState.error && (
          <LoginErrorNotification
            className={classes.notification}
            errorCode={fetchResetPasswordState.error}
            closable
            onClose={fetchResetPasswordResetState}
          />
        )}

        {fetchResetPasswordState.data && (
          <UINotification
            className={classes.notification}

            success
            title="Successful"
            text="We sent an email containing a link to reset your password. Please check your mailbox"
          />
        )}

        <div className={classes.content}>
          {!fetchResetPasswordState.data && (
            <UIForm preventDefault method='POST' onSubmit={onSubmit}>
              <UIInput
                large
                name='email'
                type='email'
                required={true}
                value={formData.email}
                onChange={onInputChange('email')}
                className={classes.formInput}
                placeholder='E-mail address'
                autoComplete='email'
              />

              <UIButton primary large className={classes.formSubmitBtn} disabled={fetchResetPasswordState.loading}>
                Reset password
              </UIButton>
            </UIForm>
          )}

          <div className={classes.goBackBlock}>
            <ReactLink to={reverse('login')}>Back to login</ReactLink>
          </div>
        </div>
      </LoginSceneLayout>
    </>
  )
}

const useStyles = createUseStyles({
  h1: {
    fontSize: 24,
    fontWeight: 500,
    textAlign: 'center',
    margin: [[12, 0, 60]]
  },

  content: {
    width: 280,
    marginLeft: 'auto',
    marginRight: 'auto',

    [mediaSizes['xs']]: {
      width: 'auto',
    },
  },

  formInput: {
    marginBottom: 12,
  },

  formSubmitBtn: {
    display: 'block',
    width: '100%',
    height: 44,
  },

  goBackBlock: {
    marginTop: 16,
    textAlign: 'center',
  },

  notification: {
    marginTop: -32,
    marginBottom: 32,
    width: 380,
    marginLeft: 'auto',
    marginRight: 'auto',
  }
});
